import React, { createContext, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "onetak_auth";
const AuthContext = createContext(null);

function readStoredAuth() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

/**
 * 로그인 상태를 로컬저장소에 지속해 새로고침/토스 결제창 리다이렉트(successUrl/failUrl 로
 * 페이지가 완전히 새로 로드됨) 이후에도 로그인 상태가 유지되도록 한다.
 */
export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(readStoredAuth);

  useEffect(() => {
    if (auth) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(auth));
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  }, [auth]);

  const login = (data) => setAuth(data);
  const logout = () => setAuth(null);

  return <AuthContext.Provider value={{ auth, login, logout }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth 는 AuthProvider 내부에서만 사용할 수 있습니다.");
  }
  return ctx;
}
